import moment, { Moment } from "moment";

const getShippingStatus = (shippingStatus: string) => {
    let deliveryStatus = '';
    let shippingIconUrl = '';
    if (shippingStatus === 'Placed' || shippingStatus === 'ArrivedForPickUp' || shippingStatus === 'Awaiting Pick' || shippingStatus === 'Picking' || shippingStatus === 'Confirmed') {
        deliveryStatus = 'Confirmed';
        shippingIconUrl = '/images/Confirmed.svg';
    }
    else if (shippingStatus === 'DeliveryRequested') {
        deliveryStatus = 'Delivery Requested';
        shippingIconUrl = '/images/Confirmed.svg';
    }
    else if (shippingStatus === 'Collected') {
        deliveryStatus = 'Collected';
        shippingIconUrl = '/images/Onitsway.svg';
    }
    else if (shippingStatus === 'DriverNotAssigned') {
        deliveryStatus = 'Driver Not Assigned';
        shippingIconUrl = '/images/Cancelled.svg';
    }
    else if (shippingStatus === 'DriverAssigned') {
        deliveryStatus = 'Driver Assigned';
        shippingIconUrl = '/images/Confirmed.svg';
    }
    else if (shippingStatus === 'Cancelled') {
        deliveryStatus = 'Cancelled';
        shippingIconUrl = '/images/Cancelled.svg';
    }
    else if (shippingStatus === 'Failed' || shippingStatus === 'DeliveryFailed') {
        deliveryStatus = 'Delivery Failed';
        shippingIconUrl = '/images/Delivery-failed.svg';
    }
    else if (shippingStatus === 'Packed') {
        deliveryStatus = 'Packed';
        shippingIconUrl = '/images/Packed.svg';
    }
    else if (shippingStatus === 'Delivered') {
        deliveryStatus = 'Delivered';
        shippingIconUrl = '/images/Delivered.svg';
    }
    else {
        deliveryStatus = 'On its way'
        shippingIconUrl = '/images/Onitsway.svg';
    }
    return {
        deliveryStatus,
        shippingIconUrl
    }
}

const getShippingType = (shippingType: string, orderDate: Moment, deliveryDate: Moment) => {
    let deliveryType = '';
    let calculatedDeliveryDate: Moment;
    let shippingIconUrl: string = '';

    if (shippingType === 'ASAP') {
        deliveryType = 'ASAP';
        shippingIconUrl = '/images/icon-track-order-jsw.svg';
        calculatedDeliveryDate = moment(deliveryDate);
    } else {
        deliveryType = shippingType;
        calculatedDeliveryDate = orderDate;
        shippingIconUrl = '/images/Onitsway.svg';
    }

    return {
        deliveryType,
        calculatedDeliveryDate,
        shippingIconUrl
    }
}

export {
    getShippingType,
    getShippingStatus
}